import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import '../Css/list.css'
import IndiceExplorer from '../Components/indiceExplorer';
import { useAuth } from "../Auth/autoContext";
import { getForecasts, getAgendaSemaine } from '../Data/dataApi';
import { getCachedForecasts, saveForecasts } from '../Data/dataCache';  // Importation des fonctions
import AgendaMini from '../Components/agendaMini';
import { Helmet } from 'react-helmet-async';

const Forecasts: React.FC = () => {
    //  Configuration for using translation with json file
    const { t } = useTranslation();
    const { role } = useAuth();
    const navigate = useNavigate();

    return (
        <>
            <Helmet>
                <title>
                    Forecasts | Stockifly
                </title>

                <meta
                    name="description"
                    content="Forecasts of stocks"
                />
            </Helmet>

            <h1 className='agenda-title'>{t('agenda.title')}</h1>
            {role === 'premium' ? (
                <AgendaMini fetchData={getAgendaSemaine} returnUrl="forecasts" />
            ) : (
                <div className="agenda-upgrade">
                    <p>{t('agenda.accessLimited')}</p>
                    <button onClick={() => navigate('/abonnements')}>
                        {t('agenda.upgrade')}
                    </button>
                </div>
            )}
            <br />
            <h1 className='list-title'>{t('list.title-forecasts')}</h1>
            <IndiceExplorer
                fetchData={getForecasts}
                returnUrl="forecasts"
                saveCache={(data, searchTerm, exchangeFilter, sortOrder, page, role) =>
                    saveForecasts(data, searchTerm, exchangeFilter, sortOrder, page, role)
                }
                getCachedData={(searchTerm, exchangeFilter, sortOrder, page, role) =>
                    getCachedForecasts(searchTerm, exchangeFilter, sortOrder, page, role)
                }
            />
        </>
    );
};

export default Forecasts;
